export default __webpack_public_path__ + "static/media/airlineLogo.a52aa10d.svg";